import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import DHPic from '../../images/Dr-haiel3.png';
import Typewriter from 'typewriter-effect';

const useStyles = makeStyles({
  root: {
    maxWidth: 500
  },
  avt: {
    marginBottom: 20,
    '&:before': {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: '30px 30px',
      backgroundRepeat: 'no-repeat',
      content: '""',
      position: 'absolute',
      left: 10,
      width: 30,
      height: 30
    }
  },
  bot: {
    maxWidth: 'fit-content'
  },
  media: {
    height: 140
  },
  divider: {
    background: '#1EB0BC'
  }
  /*text: {
    overflow: 'hidden',
    borderRight: '0.15em solid orange',
    whiteSpace: 'nowrap',
    margin: '0 auto',
    letterSpacing: '0.15em',
    animation:
      'typing 4s steps(40, end)',
      'blinkCaret .75s stepEnd infinite'
  },
  '@keyframes typing': {
    from: { width: 0 },
    to: { width: 100 % }
  },
  '@keyframes blinkCaret': {
    '0%': { borderColor: "transparent" },
    '50%': { borderColor: "orange" }
  }*/
});

const ChatMessage = ({ type, text }) => {
  const classes = useStyles();
  if (type === 'bot') {
    if (text.includes('##')) {
      const textNew = text.substring(0, text.indexOf('##'));
      const other = text.substring(text.indexOf('##') + 2);
      const urltext = other.substring(0, other.indexOf('##'));
      console.log('textNew', textNew);
      console.log('other', other);
      console.log('urltext', urltext);
      return (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: '20px',
              backgroundColor: '#E3F5F7'
            }}
          >
            <CardContent>
              <Typography
                variant="h5"
                component="h2"
                style={{ fontSize: '1rem' }}
              >
                {' '}
                {textNew}
                <Link href={urltext} target="_blank">
                  Here
                </Link>
              </Typography>
            </CardContent>
            <CardActionArea></CardActionArea>
          </Card>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <div className={classes.avt}>_</div>
          <Card
            className={(classes.root, classes.bot)}
            style={{
              marginBottom: '20px',
              backgroundColor: '#E3F5F7'
            }}
          >
            <CardContent>
              <Typography
                variant="h5"
                component="h2"
                style={{ fontSize: '1rem' }}
              >
                <Typewriter
                  options={{
                    cursor: ' ',
                    delay: 10
                  }}
                  onInit={(typewriter) => {
                    typewriter.typeString(text).start();
                  }}
                />
              </Typography>
            </CardContent>
            <CardActionArea></CardActionArea>
          </Card>
        </Fragment>
      );
    }
  }
  if (type === 'user') {
    return (
      <div className="chat-message chat-message--anchor-right">
        <p className="chat-message--user ibm-type-b"> {text} </p>
      </div>
    );
  }

  return null;
};

ChatMessage.propTypes = {
  type: PropTypes.string.isRequired,
  text: PropTypes.string
};

ChatMessage.defaultProps = {
  text: ''
};

export default ChatMessage;



// WEBPACK FOOTER //
// ./src/components/ChatMessage/ChatMessage.js